import {
  Broadcast, Envelope, Cloud, HardDrive, Cube, Scales, Gavel, Briefcase,
  Handshake, Compass, Kanban, Lightning,
} from "@phosphor-icons/react";

/** Icon per destination type (matches the DeliveryDestinations page). */
export const TYPE_ICON = {
  webhook: Broadcast,
  email: Envelope,
  crm_salesforce: Cloud,
  crm_litify: Cloud,
  crm_lawmatics: Scales,
  crm_lawruler: Gavel,
  crm_leaddocket: Briefcase,
  crm_hubspot: Handshake,
  crm_zoho: Compass,
  crm_pipedrive: Kanban,
  crm_zapier: Lightning,
  s3: Cube,
  ftp: HardDrive,
};

/**
 * Colored pill props for a success-rate percentage.
 * green ≥ 95, yellow ≥ 80, red otherwise. `null`/`undefined` → grey em-dash.
 */
export function ratePill(rate) {
  if (rate === null || rate === undefined) {
    return { label: "—", color: "border-zinc-300 text-zinc-400", bg: "bg-zinc-100" };
  }
  if (rate >= 95) return { label: `${rate}%`, color: "border-emerald-700 text-emerald-800", bg: "bg-emerald-50" };
  if (rate >= 80) return { label: `${rate}%`, color: "border-yellow-600 text-yellow-800", bg: "bg-yellow-50" };
  return { label: `${rate}%`, color: "border-red-700 text-red-800", bg: "bg-red-50" };
}

export function relativeTime(iso) {
  if (!iso) return "—";
  try {
    const then = new Date(iso).getTime();
    const secs = Math.floor((Date.now() - then) / 1000);
    if (secs < 60) return `${secs}s ago`;
    if (secs < 3600) return `${Math.floor(secs / 60)}m ago`;
    if (secs < 86400) return `${Math.floor(secs / 3600)}h ago`;
    return `${Math.floor(secs / 86400)}d ago`;
  } catch {
    return "—";
  }
}

export function untilTime(iso) {
  if (!iso) return "—";
  try {
    const then = new Date(iso).getTime();
    const secs = Math.floor((then - Date.now()) / 1000);
    if (secs <= 0) return "overdue";
    if (secs < 60) return `in ${secs}s`;
    if (secs < 3600) return `in ${Math.floor(secs / 60)}m`;
    if (secs < 86400) return `in ${Math.floor(secs / 3600)}h`;
    return `in ${Math.floor(secs / 86400)}d`;
  } catch {
    return "—";
  }
}
